import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKDialog from '@tk/components/tk.dialog';
import TKTable from '@tk/components/tk.table';
import TKStaticContent from '@tk/controls/tk.static.content';
import GTASearch from '@/controls/gta.search';
import GTADialog from '@/components/gta.dialog';
import GTAHeader from '@/components/gta.header';
import GTAUnknownCustNoHelper from '@/controls/gta.unknown.custno.helper';
import GTANavigationSidebar from '@/components/gta.navigation.sidebar';

import '@css/modules/verification.css';

export default class Verification extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-header', constructor: GTAHeader },
            { name: 'tk-nav-sidebar', constructor: GTANavigationSidebar },
            { name: 'gta-search', constructor: GTASearch },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'gta-dialog', constructor: GTADialog },
            { name: 'gta-unknown-cust-no-helper', constructor: GTAUnknownCustNoHelper },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-static-content', constructor: TKStaticContent },
        ]);
    }
}

// eslint-disable-next-line no-new
new Verification();
